export interface TenantConfig {
  name: string
  graphqlUrl: string // Legacy GraphQL API (https://...)
  servicesUrl: string // Microservices API (https://...)
  isProduction?: boolean
}

interface TenantsMap {
  [hostname: string]: TenantConfig
}

export const TENANTS: TenantsMap = {
  'app.dev.wastehero.io': {
    name: 'WasteHero Development',
    graphqlUrl: 'https://api.dev.wastehero.io/legacy',
    servicesUrl: 'https://api.dev.wastehero.io',
  },
  'app-staging.wastehero.io': {
    name: 'WasteHero Staging',
    graphqlUrl: 'https://services.wastehero.io/legacy',
    servicesUrl: 'https://services.wastehero.io',
  },
  'pjh-staging.wastehero.io': {
    name: 'PJH Staging',
    graphqlUrl: 'https://api-pjh-staging.wastehero.io/legacy',
    servicesUrl: 'https://api-pjh-staging.wastehero.io',
    isProduction: true,
  },
  'localhost:3000': {
    name: 'Local Development',
    graphqlUrl: 'https://api.dev.wastehero.io/legacy',
    servicesUrl: 'https://api.dev.wastehero.io',
  },
}

export const DEFAULT_TENANT_KEY = 'app.dev.wastehero.io'

/**
 * Returns tenant configuration based on current hostname
 * Configuration is loaded from TENANTS constant at build time
 */
export const getTenantConfig = (): TenantConfig => {
  const hostname =
    window.location.hostname +
    (window.location.port ? `:${window.location.port}` : '')

  return TENANTS[hostname] ?? TENANTS[DEFAULT_TENANT_KEY]
}
